import { createContext, type ReactNode, useContext } from 'react';
import type { Api } from '@/api/client';
import type { SessionStore } from '@/api/session';
import type { TagnDB } from '@/data/db';
import type { NotesRepository } from '@/data/notes';
import type { SyncEngine } from '@/data/sync';

/** Application services (dependency injection for components). */
export interface Services {
  api: Api;
  sessions: SessionStore;
  db: TagnDB;
  repo: NotesRepository;
  sync: SyncEngine;
}

const ServicesContext = createContext<Services | null>(null);

export function ServicesProvider({ services, children }: { services: Services; children: ReactNode }) {
  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
}

export function useServices(): Services {
  const s = useContext(ServicesContext);
  if (!s) throw new Error('useServices must be used inside <ServicesProvider>');
  return s;
}
